import React from 'react';
import classNames from 'classnames';
export interface Props {
  color?: 'pink' | 'white';
  size?: 'small' | 'normal' | 'big';
}
function BubblesLoader({
  color = 'pink',
  size = 'normal'
}: Props) {
  return <div className='flex h-full w-fit items-center justify-center gap-1' data-sentry-component="BubblesLoader" data-sentry-source-file="bubbles-loader.tsx">
            <div className={classNames({
      'h-1 w-1': size === 'small',
      'h-2 w-2': size === 'normal',
      'h-3 w-3': size === 'big'
    }, 'animate-[loading_700ms_ease-in-out_infinite] rounded-full', color === 'pink' ? 'bg-brand-primary' : 'bg-white')} />
            <div className={classNames({
      'h-1 w-1': size === 'small',
      'h-2 w-2': size === 'normal',
      'h-3 w-3': size === 'big'
    }, 'animate-[loading_700ms_ease-in-out_200ms_infinite] rounded-full', color === 'pink' ? 'bg-brand-primary' : 'bg-white')} />
            <div className={classNames({
      'h-1 w-1': size === 'small',
      'h-2 w-2': size === 'normal',
      'h-3 w-3': size === 'big'
    }, 'animate-[loading_700ms_ease-in-out_300ms_infinite] rounded-full', color === 'pink' ? 'bg-brand-primary' : 'bg-white')} />
        </div>;
}
export default BubblesLoader;